{
  "journeys-table-title": "Learning journeys",
  "new-journey-action": "Create",
  "journeys-table-key-title": "Title",
  "journeys-table-search-placeholder": "Search journey",
  "journeys-table-key-items": "Learning Items",
  "journeys-table-key-learners": "Learners",
  "journeys-table-key-completed": "Completed",
  "journeys-table-key-completion-rate": "Completion Rate",
  "journeys-table-key-status": "Status",
  "journeys-table-key-space": "Space",
  "journeys-table-value-status-published": "Published",
  "journeys-table-value-status-unpublished": "Unpublished",
  "journeys-table-tooltip-learners": "Number of learners assigned to the journey",
  "journeys-table-tooltip-completed": "Number of learners that completed the journey",
  "journeys-table-empty-state-title": "Create your first learning journey",
  "journeys-table-empty-state-subtitle": "Combine and structure learning items into a meaningful journey",
  "journeys-table-empty-state-action": "Create journey",
  "new-journey-title": "Set up your journey",
  "edit-learnings-page-title": "Learning items",
  "edit-learners-page-title": "Learners",
  "edit-learners-page-action": "add learners",
  "edit-learners-table-key-name": "name",
  "edit-learners-table-key-start-date": "joined",
  "edit-learners-table-key-completion-rate": "completion rate",
  "edit-learners-table-key-status": "Status",
  "edit-learners-table-search-placeholder": "Search by name or email",
  "edit-learners-table-remove-modal-title": "Remove learner",
  "edit-learners-table-remove-modal-content": "You will lose all progress data for ‘<strong>{{name}}</strong>‘.\n\nAre you sure you want remove this learner from the learning journey?",
  "publish-journey-title": "Review before publishing",
  "publish-journey-subtitle": " Once you publish the learning journey learners can access and find it in Search results.",
  "publish-journey-learning-items-section-title": "Learning items",
  "publish-journey-learning-items-section-counter-singular": "{{count}} learning item",
  "publish-journey-learning-items-section-counter-plural": "{{count}} learning items",
  "publish-journey-learning-items-section-warning": "At least one learning item is required for publishing",
  "publish-journey-learning-items-section-action": "Add learning items",
  "publish-journey-learners-section-title": "Learners",
  "publish-journey-learners-section-counter-singular": "{{count}} learners",
  "publish-journey-learners-section-counter-plural": "{{count}} learners",
  "publish-journey-completion-criteria-section-title": "Completion criteria",
  "publish-journey-completion-criteria-section-invest": "Invest Time",
  "publish-journey-completion-criteria-section-complete-all": "Complete all items",
  "publish-journey-card-action": "Publish",
  "add-learnings-modal-nodata-title": "No learning items available",
  "add-learnings-modal-nodata-subtitle": "Create learning items to build your journey",
  "add-learnings-modal-nodata-action": "Go Create",
  "add-learners-modal-nodata-title": "No learners available",
  "add-learners-modal-nodata-subtitle": "Invite learners to the platform and populate your list",
  "add-learners-modal-nodata-action": "Go Invite",
  "notification-journey-updated": "Journey updated",
  "notification-journey-updated-status-published": "Journey published",
  "notification-journey-updated-status-unpublished": "Journey unpublished",
  "notification-journey-updated-completion-criteria": "Completion criteria updated",
  "notification-journey-updated-description": "Description updated",
  "notification-journey-updated-certificate": "Certificate setting updated",
  "notification-journey-certificate-properties-saved": "Certificate updated",
  "notification-journey-updated-learners": "Learners updated"
}
